import * as types from '../const/action.types';

export function reportAPPCCIsLoading(state = false, action) {
    switch (action.type) {
        case types.REPORT_APPCC_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function appcc(state = {}, action) {
    switch (action.type) {
        case types.REPORT_APPCC_FETCH_DATA:
            return action.items;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/api.reports.appcc.reducer.js